var exports = {
  "F": "xdde3148b--f79a5a--link-container",
  "n": "xdde3148b--f79a5a--link",
};

module.exports = exports;
